import React from 'react';
import type { Project } from '../../data/portfolioProjects';
const accentHex = {
  orange: '#FF6B18',
  green: '#12C777',
  cyan: '#2BB6EE',
  blue: '#2F6BFF'
} as const;

/**
 * Abstract wireframe of the site structure we built — deliberately not a fake screenshot
 * and never a fake brand name.
 */
export function ProjectFrame({
  project
}: {
  project: Project;
}) {
  const color = accentHex[project.accent];
  const grid = ['catalog', 'store', 'listings'].includes(project.layout);
  const split = ['gallery', 'specs', 'membership'].includes(project.layout);
  return <div className="relative h-40 overflow-hidden border-b border-white/10 bg-navy-800" data-id="element-462" data-mp="1jz9dm67x2yau">
      <div className="absolute inset-0 bp-fine opacity-70" aria-hidden="true" data-id="element-463" data-mp="1k1m3d5jx2cyg" />
      <div className="absolute inset-0 p-4" data-id="element-464" data-mp="1oym9fggrnfpk">
        <div className="flex h-full flex-col gap-2" data-id="element-465" data-mp="3ecsi600d7h5n">
          {/* nav bar */}
          <div className="flex items-center gap-2" data-id="element-466" data-mp="3jcdgc87pnlhb">
            <span className="h-2.5 w-2.5 rounded-sm" style={{
            backgroundColor: color
          }} data-id="element-467" data-mp="3jb2g2idh4vuy" />
            <span className="h-1.5 w-14 rounded bg-white/15" data-id="element-468" data-mp="3ki6r0ryp3l4y" />
            <span className="ml-auto flex items-center gap-1.5" data-id="element-469" data-mp="3fkdk1wpkin3m">
              <span className="h-1.5 w-7 rounded bg-white/10" data-id="element-470" data-mp="3fjvickk4zgob" />
              <span className="h-1.5 w-7 rounded bg-white/10" data-id="element-471" data-mp="3tagza3q15gjk" />
              <span className="h-3.5 w-10 rounded" style={{
              backgroundColor: color,
              opacity: 0.85
            }} data-id="element-472" data-mp="3p9x77ekbd34a" />
            </span>
          </div>

          {grid && <div className="grid flex-1 grid-cols-4 gap-1.5" data-id="element-473" data-mp="31kvzjtjb1w02">
              {Array.from({
            length: 8
          }).map((_, n) => <div key={n} className="rounded bg-white/[0.07] p-1.5" data-id="element-474" data-mp="2wnm49x98iq4b" data-mpi={n}>
                  <div className="h-1/2 rounded bg-white/10" data-id="element-475" data-mp="3amlsx4wqz50h" />
                  <div className="mt-1 h-1 w-3/4 rounded bg-white/15" data-id="element-476" data-mp="35lod2yz7mn25" />
                  <div className="mt-1 h-1 w-1/2 rounded" style={{
              backgroundColor: color,
              opacity: 0.7
            }} data-id="element-477" data-mp="putg9longlsi" />
                </div>)}
            </div>}

          {split && <div className="flex flex-1 gap-2" data-id="element-478" data-mp="3enoxffjgx8kt">
              <div className="flex w-1/2 flex-col gap-1.5 rounded bg-white/[0.07] p-2" data-id="element-479" data-mp="3emwybuqnwsps">
                <div className="h-2 w-3/4 rounded bg-white/20" data-id="element-480" data-mp="3jlqexw18wzu6" />
                <div className="h-1.5 w-full rounded bg-white/10" data-id="element-481" data-mp="3nod8c1dkesth" />
                <div className="h-1.5 w-5/6 rounded bg-white/10" data-id="element-482" data-mp="3np6ccul5347x" />
                <div className="mt-auto h-5 w-20 rounded" style={{
              backgroundColor: color
            }} data-id="element-483" data-mp="3smeu4u2dl68n" />
              </div>
              <div className="grid w-1/2 grid-cols-2 gap-1.5" data-id="element-484" data-mp="2vys1l78fa80h">
                {Array.from({
              length: 4
            }).map((_, n) => <div key={n} className="rounded" style={{
              backgroundColor: n === 0 ? color : 'rgba(255,255,255,0.08)',
              opacity: n === 0 ? 0.35 : 1
            }} data-id="element-485" data-mp="2zwpsqflr746i" data-mpi={n} />)}
              </div>
            </div>}

          {!grid && !split && <div className="flex flex-1 gap-2" data-id="element-486" data-mp="2h7svq3yz1xkl">
              <div className="flex w-3/5 flex-col gap-1.5 rounded bg-white/[0.07] p-2" data-id="element-487" data-mp="2h6hsc59furu0">
                <div className="h-2 w-2/3 rounded bg-white/20" data-id="element-488" data-mp="29o9uehlv1hn7" />
                <div className="h-5 rounded bg-white/[0.09]" data-id="element-489" data-mp="24p72lyuw57x6" />
                <div className="h-5 rounded bg-white/[0.09]" data-id="element-490" data-mp="24nvwvthvxq3f" />
                <div className="mt-auto h-5 w-20 rounded" style={{
              backgroundColor: color
            }} data-id="element-491" data-mp="1zpatxmb90sba" />
              </div>
              <div className="grid w-2/5 grid-cols-3 grid-rows-4 gap-1 rounded bg-white/[0.07] p-1.5" data-id="element-492" data-mp="1vohb37cny3p9">
                {Array.from({
              length: 12
            }).map((_, n) => <span key={n} className="rounded-sm" style={{
              backgroundColor: n % 4 === 0 ? color : 'rgba(255,255,255,0.10)'
            }} data-id="element-493" data-mp="1lyxlliug3blf" data-mpi={n} />)}
              </div>
            </div>}
        </div>
      </div>
    </div>;
}